module.exports = __webpack_public_path__ + "_SiteHeader-static.html";